import React, { useEffect, useState } from 'react';
import { Avatar, AvatarFallback } from '../ui/avatar';
import { useAuth } from '../../contexts/AuthContext';

const photoCache = new Map();

// List-row avatar: shows the person's uploaded profile photo when present
// (fetched with auth, cached per file id), otherwise coloured initials.
export const PersonAvatar = ({ person, fallbackClass, testid, onClick }) => {
  const { api } = useAuth();
  const photo = person?.photo;
  const [url, setUrl] = useState(() => (photo?.id && photoCache.get(photo.id)) || null);

  useEffect(() => {
    if (!photo?.id || !photo?.url) { setUrl(null); return undefined; }
    const cached = photoCache.get(photo.id);
    if (cached) { setUrl(cached); return undefined; }
    let cancelled = false;
    api.get(photo.url.replace(/^\/api/, ''), { responseType: 'blob' })
      .then((r) => {
        const obj = URL.createObjectURL(r.data);
        photoCache.set(photo.id, obj);
        if (!cancelled) setUrl(obj);
      })
      .catch(() => { if (!cancelled) setUrl(null); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photo?.id]);

  const initials = (person?.full_name || person?.name || '?')
    .split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();

  return (
    <Avatar data-testid={testid} onClick={onClick} className={`rounded-lg ${onClick ? 'cursor-pointer' : ''}`} title={onClick ? 'View profile' : undefined}>
      {url ? (
        <img src={url} alt={person?.full_name || ''} className="w-full h-full object-cover" />
      ) : (
        <AvatarFallback className={`rounded-lg ${fallbackClass || ''}`}>{initials}</AvatarFallback>
      )}
    </Avatar>
  );
};
